import { render, staticRenderFns } from "./RestaurantGroupMealsStats.vue?vue&type=template&id=709a2600&scoped=true"
import script from "./RestaurantGroupMealsStats.vue?vue&type=script&lang=js"
export * from "./RestaurantGroupMealsStats.vue?vue&type=script&lang=js"
import style0 from "./RestaurantGroupMealsStats.vue?vue&type=style&index=0&id=709a2600&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709a2600",
  null
  
)

export default component.exports